import LoadingButton from "@mui/lab/LoadingButton/LoadingButton";
import Alert from "@mui/material/Alert/Alert";
import Card from "@mui/material/Card/Card";
import CardContent from "@mui/material/CardContent/CardContent";
import Divider from "@mui/material/Divider/Divider";
import FormControl from "@mui/material/FormControl/FormControl";
import FormHelperText from "@mui/material/FormHelperText/FormHelperText";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Select from "@mui/material/Select/Select";
import Stack from "@mui/material/Stack/Stack";
import TextField from "@mui/material/TextField/TextField";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSendFBAnalyticsEvent } from "../hooks/analytics";
import { useDeployMutation, useDeployPrice } from "../libs/deployerService";

export const DeployDao = () => {
  const navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [symbol, setSymbol] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [quorum, setQuorum] = useState("1/2");
  const [decimals, setDecimals] = useState("9");

  const { data: price } = useDeployPrice();
  const sendFBAnalyticsEvent = useSendFBAnalyticsEvent();
  const { mutateAsync, isLoading, error, reset } = useDeployMutation();
  const disabled = isLoading;

  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    setSubmitted(true);

    reset();

    if (!name || !description || !image || !amount || !symbol) {
      return;
    }

    sendFBAnalyticsEvent("create_dao");
    const address = await mutateAsync({
      name,
      image,
      description,
      symbol,
      amount,
      quorum,
      decimals,
    });

    navigate(`/${address}`);
  };
  return (
    <Card sx={{ my: 2 }}>
      <CardContent>
        <FormControl
          component="form"
          onSubmit={onSubmit}
          disabled={disabled}
          fullWidth
        >
          <Stack gap={2}>
            <div>
              <FormHelperText sx={{ mx: "12px" }}>DAO Name</FormHelperText>
              <TextField
                fullWidth
                value={name}
                disabled={disabled}
                onChange={(e) => setName(e.target.value)}
                error={submitted && !name}
                helperText={
                  submitted && !name ? "Field is required" : undefined
                }
              />
            </div>

            <div>
              <FormHelperText sx={{ mx: "12px" }}>
                Logo Image URL
              </FormHelperText>
              <TextField
                fullWidth
                label=""
                value={image}
                disabled={disabled}
                onChange={(e) => setImage(e.target.value)}
                error={submitted && !image}
                helperText={
                  submitted && !image ? "Field is required" : undefined
                }
              />
            </div>

            <div>
              <FormHelperText sx={{ mx: "12px" }}>Description</FormHelperText>
              <TextField
                fullWidth
                multiline
                rows={2}
                disabled={disabled}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                error={submitted && !description}
                helperText={
                  submitted && !description ? "Field is required" : undefined
                }
              />
            </div>

            <div>
              <FormHelperText sx={{ mx: "12px" }}>Quorum Params</FormHelperText>
              <Select
                fullWidth
                disabled={disabled}
                value={quorum}
                onChange={(e) => setQuorum(e.target.value)}
              >
                <MenuItem value="2/3">66%</MenuItem>
                <MenuItem value="1/2">50%</MenuItem>
                <MenuItem value="1/4">25%</MenuItem>
                <MenuItem value="1/10">10%</MenuItem>
              </Select>
            </div>

            <Divider />

            <div>
              <FormHelperText sx={{ mx: "12px" }}>Jetton Amount</FormHelperText>

              <TextField
                fullWidth
                type="number"
                disabled={disabled}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                error={submitted && !amount}
                helperText={
                  submitted && !amount ? "Field is required" : undefined
                }
              />
            </div>

            <div>
              <FormHelperText sx={{ mx: "12px" }}>Jetton Symbol</FormHelperText>

              <TextField
                fullWidth
                disabled={disabled}
                value={symbol}
                onChange={(e) => setSymbol(e.target.value)}
                error={submitted && !symbol}
                helperText={
                  submitted && !symbol ? "Field is required" : undefined
                }
              />
            </div>

            <div>
              <FormHelperText sx={{ mx: "12px" }}>
                Jetton decimals
              </FormHelperText>
              <Select
                fullWidth
                disabled={disabled}
                value={decimals}
                onChange={(e) => setDecimals(e.target.value)}
              >
                <MenuItem value="0">0</MenuItem>
                <MenuItem value="3">3</MenuItem>
                <MenuItem value="6">6</MenuItem>
                <MenuItem value="9">9</MenuItem>
                <MenuItem value="18">18</MenuItem>
              </Select>
            </div>

            <Divider />

            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              loading={isLoading}
              disabled={disabled}
            >
              Deploy{price ? ` ${price} - TON` : ""}
            </LoadingButton>
            {error && <Alert severity="error">{error.message}</Alert>}
          </Stack>
        </FormControl>
      </CardContent>
    </Card>
  );
};
